/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */
import blockTypes from '../blocks/blockTypes.js';
import { generateElementId } from '@oat-sa-private/ui-core';

/**
 * Prepares rubric block element and injects it to itemData
 * @param {object} itemData
 * @param {string} rubricBlockBody
 * @returns {object} itemData
 */
export const prepareRubricBlock = (itemData, rubricBlockBody) => {
    if (!rubricBlockBody) {
        return itemData;
    }

    if (!itemData.itemData.data.body) {
        return itemData;
    }

    const rubricBlockQtiClass = 'rubricBlock';
    let itemDataBody = itemData.itemData.data.body;

    let alreadyExists = false;
    for (const key of Object.keys(itemDataBody.elements)) {
        alreadyExists = itemDataBody.elements[key].qtiClass === rubricBlockQtiClass;
        if (alreadyExists) {
            return itemData;
        }
    }

    const rubricBlockId = generateElementId('rubricBlock');
    itemDataBody.body = `{{${rubricBlockId}}}${itemDataBody.body}`;
    itemDataBody.elements[rubricBlockId] = {
        qtiClass: rubricBlockQtiClass,
        type: blockTypes.element,
        attributes: {
            body: rubricBlockBody
        }
    };

    return itemData;
};
